<template>
    <div>
        <div class="user_bor box">


            <div class="user_box">
                <div class="user_box_left">
                    {{$t('m.address_01')}}
                </div>
                <div class="user_box_right">

                </div>

            </div>
            <div class="add_btn pointer" @click="add_">
                <span>{{$t('m.address_02')}}</span>
                <img src="../../static/add_icon.png" alt="">
            </div>
            <state v-if="!address_list.length"></state>
            <div class="address_info pointer" v-for="(item, index) in address_list" :key="index" v-if="address_list.length"
                @click="choice(index)">
                <div class="address_left">
                    <span class="name">
                        {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.mobile }}
                    </span>
                    <span class="dizhi">
                        {{$t('m.home_12')}}：{{ item.address }}
                    </span>
                </div>
                <div class="address_right">
                    <div class="btnbox pointer" @click.stop="edit_(item)">
                        <img src="../../static/bianji.png" alt="">
                        <span>{{$t('m.address_03')}}</span>
                    </div>
                    <div class="btnbox1 pointer" @click.stop="delete_(item.id)">
                        <img src="../../static/shanchu_icon.png" alt="">
                        <span>{{$t('m.address_04')}}</span>
                    </div>
                </div>
            </div>

            <div class="foot_box"></div>


        </div>



        <el-dialog :title="show_title" :visible.sync="showbox" width="680px" center>
            <div class="showbox">

                <div class="from_box">
                    <div class="inpu_box">
                        <div class="inpu_title">
                            {{$t('m.address_05')}}:
                        </div>
                        <div class="inpu_main">
                            <el-input v-model="param.name" :placeholder="$t('m.address_09')"></el-input>
                        </div>
                    </div>
                </div>
                <div class="from_box">
                    <div class="inpu_box">
                        <div class="inpu_title">
                            {{$t('m.address_06')}}:
                        </div>
                        <div class="inpu_main">
                            <el-input v-model="param.mobile" :placeholder="$t('m.address_10')"></el-input>
                        </div>
                    </div>
                </div>
                <div class="from_box">
                    <div class="inpu_box1">
                        <div class="inpu_title">
                            {{$t('m.address_07')}}:
                        </div>
                        <div class="inpu_main1">

                            <el-input type="textarea" :rows="3" :placeholder="$t('m.address_11')" v-model="param.address">
                            </el-input>
                        </div>
                    </div>
                </div>
                <div class="foot_btnbox">


                    <div class="btnbox1 foot_btnboxli pointer" @click="showbox = false">
                        <span>{{$t('m.address_08')}}</span>
                    </div>
                    <div class="btnbox foot_btnboxli pointer" @click="confirm">
                        <span>{{ btn_title }}</span>
                    </div>

                </div>
            </div>

        </el-dialog>
<div class="showbox3">
        <el-dialog :visible.sync="Receiving_show" :show-close="false" width="350px" center>
            <div class="showbox2">
                <!-- <div class="bar">—</div> -->
                <div class="title">{{$t('m.address_12')}}</div>
                <p>{{$t('m.address_13')}}？</p>
                <div class="btnboxli">
                    <div class="btnbox1 pointer" @click="Receiving_show = false">
                        <span>{{$t('m.address_08')}}</span>
                    </div>
                    <div class="btnbox pointer" @click="shanchu()">
                        <span>{{$t('m.address_14')}}</span>
                    </div>

                </div>
            </div>

        </el-dialog>
</div>
    </div>
</template>
<script>

import encryption from '@/utils/encryption.js'
import state from '@/components/state.vue'
export default {
    components: {
        state
    },
    data() {
        return {
            Receiving_show:false,
            name: '',
            showbox: false,
            show_title: this.$t('m.address_15'),
            btn_title: this.$t('m.address_16'),
            address_id: '', //地址id
            address_list: [],
            type: 'add',  //add==>添加 edit==>编辑
            user_data: {},
            param: {
                name: '',
                mobile: '',
                address: ''
            },
            pageType: '',
            address_id1:""
        }
    },
    created() {

    },
    mounted() {
        if (this.$route.query.pageType) {
            this.pageType = this.$route.query.pageType
        }
        this.user_data = JSON.parse(localStorage.getItem('user_data'))
        this.getData()
    },
    methods: {
        choice(index) {
            localStorage.setItem('address', JSON.stringify(this.address_list[index]))
            if (this.pageType == 'modify') {
                this.$router.go(-1);
            } else {
                this.$message.success(this.$t('m.address_17'))
            }

        },
        getData() {
            let param = {
                user_id: this.user_data.id
            }
            let sing = encryption.getSing(param)
            this.$api.address_list(param, sing).then((res) => {
                if (res.data.code == 1) {
                    this.address_list = res.data.data || []
                }
            })
        },
        //添加
        add_() {
            this.showbox = true
            this.show_title = this.$t('m.address_15')
            this.btn_title = this.$t('m.address_16')
            this.type = 'add'
            this.param={
                name: '',
                mobile: '',
                address: ''
            }
        },
        //编辑
        edit_(item) {
            this.showbox = true
            this.type = 'edit'
            this.show_title = this.$t('m.address_18')
            this.btn_title = this.$t('m.address_19')
            this.address_id = item.id
            this.param.name = item.name
            this.param.mobile = item.mobile
            this.param.address = item.address

        },
        confirm() {
            let param = this.param
            param.user_id = this.user_data.id

            if (!param.name) {
                this.$message.warning(this.$t('m.address_20'))
            } else if (!param.mobile) {
                this.$message.warning(this.$t('m.address_21'))
            } else if (!param.address) {
                this.$message.warning(this.$t('m.address_22'))
            } else {
                if (this.btn_title == this.$t('m.address_16')) {
                    let sing = encryption.getSing(param)
                    this.$api.address_add(param, sing).then((res) => {
                        if (res.data.code == 1) {
                            this.$message.success(this.$t('m.address_23'))
                            this.showbox = false
                            this.getData()
                        }
                    })


                }
                if (this.btn_title == this.$t('m.address_19')) {
                    console.log(55555555555555)
                    param.address_id = this.address_id
                    let sing = encryption.getSing(param)
                    this.$api.address_edit(param, sing).then((res) => {
                        if (res.data.code == 1) {
                            this.$message.success(this.$t('m.address_24'))
                            this.showbox = false
                            this.getData()
                        }
                    })
                }
            }



        },
        shanchu(){
            let param = {
                    user_id: this.user_data.id,
                    address_id: this.address_id1
                }
                let sing = encryption.getSing(param)
                this.$api.address_del(param, sing).then((res) => {
                    if (res.data.code == 1) {
                        this.$message.success(this.$t('m.address_25'))
                        this.Receiving_show=false
                        this.getData()
                    }
                })

        },
        //删除
        delete_(address_id) {
            this.Receiving_show=true
            this.address_id1 = address_id
            
        }
    }
}
</script>
<style lang="scss" scoped>
// .box {
//     min-width: 800px;
// }

.user_box {

    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;
    padding-left: 20px;

    .user_box_left {
        padding-left: 25px;
    }

}

.foot_box {
    height: 100px;
}

.address_info {
    width: calc(100% - 100px);
    margin: 0 auto;
    margin-top: 30px;
    padding: 20px 30px;
    border: 1px solid #e5e5e5;
    border-radius: 1px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    .address_left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-weight: bold;

        .dizhi {
            margin-top: 16px;
        }
    }

    .address_right {
        display: flex;
        align-items: center;


    }

}

.add_btn {


    width: calc(100% - 100px);
    margin: 0 auto;
    margin-top: 30px;
    background-color: #ef5843;
    justify-content: center;
    height: 60px;
    line-height: 60px;
    color: #fff;
    display: flex;
    align-items: center;

    span {

        font-size: 15px;
        font-weight: bold;
    }

    img {
        margin-left: 10px;
        width: 17px;
        height: 17px;
    }
}

.showbox {
    background-color: #fff;


    padding: 0 30px;

    .foot_btnbox {
        display: flex;
        align-items: center;
        margin-top: 30px;
        justify-content: space-between;
        padding: 0 20px;

        .foot_btnboxli {
            width: 140px;
            height: 45px !important;
            margin: 0 !important;
        }
    }

    .from_box {
        .inpu_box1 {
            width: 100%;
            margin-top: 20px;
            background-color: #f6f7fa;

            border-radius: 4px;
            padding: 0 20px;
            height: auto;
            // line-height: 150px;
            padding-bottom: 20px;

            .inpu_title {
                font-weight: bold;

                height: 40px;
                line-height: 40px;
            }

            .inpu_main {


                height: 90px;

                ::v-deep .el-textarea {
                    display: block !important;
                }


            }

            .inpu_main1 {
                height: auto;

                ::v-deep .el-textarea__inner {
                    border: 0 !important;
                    background-color: #f6f7fa;
                    padding: 0 !important;
                }
            }
        }

        .inpu_box {
            width: 100%;
            margin-top: 20px;
            background-color: #f6f7fa;
            display: flex;
            align-items: center;
            border-radius: 4px;
            padding: 0 20px;
            height: 50px;
            line-height: 50px;

            .inpu_title {
                font-weight: bold;
            }

            .inpu_main {
                margin-left: 10px;
                flex: 1;

                ::v-deep .el-input__inner {
                    border: 0 !important;
                    background-color: #f6f7fa;
                }
            }
        }
    }
}

.btnbox {
    background-color: #ef5843;
    height: 38px;
    width: 90px;
    display: flex;
    align-items: center;
    color: #fff;
    border-radius: 4px;
    justify-content: center;

    span {
        margin-left: 6px;
    }
}

.btnbox1 {
    background-color: #fff;
    color: #ef5843;
    border: 2px solid #ef5843;
    border-radius: 4px;
    height: 38px;
    width: 90px;
    margin-left: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
        margin-left: 6px;
    }
}

::v-deep .el-dialog__body {
    padding: 0 10px 30px 10px !important;
}

.showbox3{
    ::v-deep .el-dialog__header {
        padding: 0 !important;
    }

    ::v-deep .el-dialog__body {
        padding: 0 !important;
    }

    ::v-deep .el-dialog {
        margin-top: 35vh !important;
        border-radius: 4px;
        border-top: 5px solid #ef5843;
    }
}

.showbox2 {
    padding: 30px;
    background-color: #fff;
    border-radius: 4px;

    .bar {
        font-weight: bold;
        text-align: center;
    }

    .title {
        font-size: 22px;
        font-weight: bold;
        text-align: center;
        margin-top: 0 !important;

    }

    p {
        margin-top: 10px;
        text-align: center;
    }

    .btnboxli {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;


        .btnbox {
            background-color: #ef5843;
            height: 54px;
            width: 120px;
            display: flex;
            align-items: center;
            color: #fff;
            border-radius: 4px;
            justify-content: center;
            margin-left: 20px;

            span {
                font-weight: bold;
            }

        }

        .btnbox1 {
            background-color: #fff;
            color: #ef5843;
            border: 3px solid #ef5843;
            border-radius: 4px;
            height: 54px;
            width: 120px;

            span {
                font-weight: bold;
            }

            display: flex;
            align-items: center;
            justify-content: center;


        }
    }
}


// 宽度小于1200px
@media screen and (max-width: 1200px){
	.user_box{
		padding: 0;
	}
	.add_btn{
		width: auto;
		margin: 0 0.5rem;
		margin-top: 1rem;
	}
	.address_info{
		width: auto;
		margin: 0 0.5rem;
		margin-top: 1rem;
		padding: 0.5rem;
		display: block;
		.address_left{
			span{
				&:last-child{
					margin-top: 0.5rem;
				}
			}
		}
		.address_right{
			margin-top: 1rem;
		}
	}
	.inpu_box1{
		.inpu_main{
			height: auto!important;
			::v-deep.el-input__inner{
				border: none!important;
				background: none!important;
				padding: 0;
			}
		}
	}
	.foot_btnbox{
		>div{
			width: 48%!important;
		}
	}
}

</style>